import { all, call, put, takeEvery } from 'redux-saga/effects'
import { message } from 'antd'
import * as api from './api'
import * as actions from './actions'

function* fetchEngagementMetricsWorker({ payload }) {
  try {
    yield put(actions.setLoading({ key: 'engagementMetrics', value: true }))
    const response = yield call(api.getEngagementMetrics, payload)
    yield put(
      actions.fetchEngagementMetricsSuccess({
        data: [response?.data?.data],
        page: payload.page || 1,
        pageCount: response?.data?.meta?.page_count,
      })
    )
  } catch (error) {
    yield put(actions.fetchEngagementMetricsFailure())
    console.error(error)
  } finally {
    yield put(actions.setLoading({ key: 'engagementMetrics', value: false }))
  }
}

function* fetchPaymentTransactionsWorker({ payload }) {
  try {
    yield put(actions.setLoading({ key: 'paymentTransactions', value: true }))
    const response = yield call(api.getPaymentTransactions, payload)
    yield put(
      actions.savePaymentTransactions({
        data: response?.data?.data,
        page: payload.page || 1,
        pageCount: response?.data?.meta?.page_count,
      })
    )
  } catch (error) {
    console.error(error)
  } finally {
    yield put(actions.setLoading({ key: 'paymentTransactions', value: false }))
  }
}

function* deleteUserWorker({ payload }) {
  try {
    const { data } = yield call(api.deleteUser, payload)
    if (data) {
      yield put(actions.deleteUserSuccess())
    } else {
      yield put(actions.deleteUserFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.deleteUserFailure())
  }
}

function* verifyPayPalWorker({ payload }) {
  try {
    const { data } = yield call(api.sendPayPalEmailToUser, payload)
    if (data) {
      yield put(actions.verifyUserPayPalSuccess())
    } else {
      yield put(actions.verifyUserPayPalFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.verifyUserPayPalFailure())
  }
}

function* confirmPayPalWorker({ payload }) {
  try {
    const { data } = yield call(api.confirmPayPal, payload)
    if (data) {
      yield put(actions.confirmPayPalSuccess())
    } else {
      yield put(actions.confirmPayPalFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.confirmPayPalFailure())
  }
}

function* updateUserWorker({ payload }) {
  try {
    const { data } = yield call(api.updateUser, payload)
    if (data) {
      yield put(actions.updateUserSuccess())
    } else {
      yield put(actions.updateUserFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.updateUserFailure())
  }
}

function* resetUserPasswordWorker({ payload }) {
  try {
    const apiResponse = yield call(api.resetUserPassword, payload)
    if (apiResponse?.new_password) {
      yield put(actions.setUser({ password: apiResponse.new_password }))
      yield put(actions.resetUserPasswordSuccess())
    } else {
      yield put(actions.resetUserPasswordFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.resetUserPasswordFailure())
  }
}

function* unblockUserPaymentWorker({ payload }) {
  try {
    const apiResponse = yield call(api.unblockUserPayment, payload)
    if (apiResponse) {
      yield put(actions.unblockUserPayment())
      yield put(actions.unblockUserPaymentSuccess())
    } else {
      yield put(actions.unblockUserPaymentFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.unblockUserPaymentFailure())
  }
}

function* mergeUserWorker({ payload }) {
  try {
    const response = yield call(api.mergeUser, payload)
    if (response?.data) {
      yield put(actions.mergeUserSuccess())
    } else {
      yield put(actions.mergeUserFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.mergeUserFailure())
  }
}

function* fetchUsersWorker({ payload }) {
  try {
    const { data } = yield call(api.getUsers, payload)
    yield put(
      actions.fetchUsersSuccess({
        ...payload,
        page: payload.page,
        pageCount: data.meta?.page_count,
        users: data.data,
      })
    )
  } catch (error) {
    console.error(error)
    yield put(actions.fetchUsersFailure())
  }
}

function* sendSMSVerificationWorker({ payload }) {
  try {
    const response = yield call(api.sendSMSVerification, payload)
    if (response) {
      yield put(actions.sendSMSVerificationSuccess(response))
    }
  } catch (error) {
    console.error(error)
    yield put(actions.sendSMSVerificationFailure())
  }
}

function* unsubscribeUserWorker({ payload }) {
  try {
    const { data } = yield call(api.unsubscribeUser, payload)
    if (data) {
      yield put(actions.unsubscribeUserSuccess())
    } else {
      yield put(actions.unsubscribeUserFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.unsubscribeUserFailure())
  }
}

function* fetchBonusesForUserWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchBonusesForUser, payload)
    if (data) {
      yield put(actions.fetchBonusesForUserSuccess(data))
    } else {
      yield put(actions.fetchBonusesForUserFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchBonusesForUserFailure())
  }
}

function* fetchWalletHistoryForUserWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchWalletHistoryForUser, payload)
    if (data) {
      yield put(actions.fetchWalletHistoryForUserSuccess(data))
    } else {
      yield put(actions.fetchWalletHistoryForUserFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchWalletHistoryForUserFailure())
  }
}

function* fetchEarnOffersWorker({ payload }) {
  try {
    const response = yield call(api.getEarnOffers, payload)
    if (response?.data?.data) {
      yield put(actions.fetchEarnOffersSuccess(response.data.data))
    } else {
      yield put(actions.fetchEarnOffersFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchEarnOffersFailure())
  }
}

function* createEarnGoalWorker({ payload }) {
  try {
    yield put(actions.setEarnGoalSubmitting(true))
    yield call(api.createEarnGoal, payload)
    message.success('Goal created successfully.')
    yield put(actions.createEarnGoalSuccess())
    yield put(actions.fetchEarnOffers(payload.userId))
  } catch (error) {
    console.error(error)
    const status = error?.response?.status
    if (status === 403) {
      message.warning('This action is not available in production.')
    } else if (status === 422) {
      const errors = error?.response?.data?.error
      if (Array.isArray(errors)) {
        errors.forEach((e) => message.error(e))
      } else if (errors) {
        message.error(errors)
      } else {
        message.error('Validation error.')
      }
    } else {
      message.error('Failed to create goal.')
    }
    yield put(actions.createEarnGoalFailure())
  } finally {
    yield put(actions.setEarnGoalSubmitting(false))
  }
}

function* createCompliantEarnGoalWorker({ payload }) {
  try {
    yield put(actions.setEarnGoalSubmitting(true))
    yield put(actions.clearCompliantEarnGoalFeedback())

    const response = yield call(api.createCompliantEarnGoal, payload)
    const compliantGoal = response?.data

    if (compliantGoal?.valid) {
      yield put(actions.saveCompliantEarnGoalResult(compliantGoal))
      message.success(
        `Goal created successfully. Goal ID: ${compliantGoal.goal_id}.`
      )
      yield put(actions.createCompliantEarnGoalSuccess(compliantGoal))
      yield put(actions.fetchEarnOffers(payload.userId))
    } else {
      const errorPayload = {
        valid: false,
        code: compliantGoal?.code,
        message: compliantGoal?.message || 'Failed to create compliant goal.',
      }

      message.error(errorPayload.message)
      yield put(actions.saveCompliantEarnGoalError(errorPayload))
      yield put(actions.createCompliantEarnGoalFailure(errorPayload))
    }
  } catch (error) {
    console.error(error)

    const backendError = error?.response?.data
    const errorPayload = {
      valid: false,
      code: backendError?.code,
      message: backendError?.message || 'Failed to create compliant goal.',
    }

    message.error(errorPayload.message)
    yield put(actions.saveCompliantEarnGoalError(errorPayload))
    yield put(actions.createCompliantEarnGoalFailure(errorPayload))
  } finally {
    yield put(actions.setEarnGoalSubmitting(false))
  }
}

function* updateEarnGoalWorker({ payload }) {
  try {
    yield put(actions.setEarnGoalSubmitting(true))
    yield call(api.updateEarnGoal, payload)
    message.success('Goal updated successfully.')
    yield put(actions.updateEarnGoalSuccess())
    yield put(actions.fetchEarnOffers(payload.userId))
  } catch (error) {
    console.error(error)
    const status = error?.response?.status
    if (status === 403) {
      message.warning('This action is not available in production.')
    } else if (status === 422) {
      const errors = error?.response?.data?.error
      if (Array.isArray(errors)) {
        errors.forEach((e) => message.error(e))
      } else if (errors) {
        message.error(errors)
      } else {
        message.error('Validation error.')
      }
    } else {
      message.error('Failed to update goal.')
    }
    yield put(actions.updateEarnGoalFailure())
  } finally {
    yield put(actions.setEarnGoalSubmitting(false))
  }
}

export default function* () {
  yield all([
    takeEvery(actions.fetchUsers, fetchUsersWorker),
    takeEvery(actions.fetchPaymentTransactions, fetchPaymentTransactionsWorker),
    takeEvery(actions.fetchEngagementMetrics, fetchEngagementMetricsWorker),
    takeEvery(actions.deleteUser, deleteUserWorker),
    takeEvery(actions.verifyUserPayPal, verifyPayPalWorker),
    takeEvery(actions.updateUser, updateUserWorker),
    takeEvery(actions.mergeUser, mergeUserWorker),
    takeEvery(actions.resetUserPassword, resetUserPasswordWorker),
    takeEvery(actions.unblockUserPayment, unblockUserPaymentWorker),
    takeEvery(actions.sendSMSVerification, sendSMSVerificationWorker),
    takeEvery(actions.unsubscribeUser, unsubscribeUserWorker),
    takeEvery(actions.fetchBonusesForUser, fetchBonusesForUserWorker),
    takeEvery(actions.confirmPayPal, confirmPayPalWorker),
    takeEvery(actions.fetchWalletHistoryForUser, fetchWalletHistoryForUserWorker),
    takeEvery(actions.fetchEarnOffers, fetchEarnOffersWorker),
    takeEvery(actions.createEarnGoal, createEarnGoalWorker),
    takeEvery(actions.createCompliantEarnGoal, createCompliantEarnGoalWorker),
    takeEvery(actions.updateEarnGoal, updateEarnGoalWorker),
  ])
}
